/**
 * 查看详情
 * 2017-12-27
 * by 于再洋
 */
"use strict";
angular.module("breditruleModule", []).
controller("breditruleCtrl", ["$scope", '$modalInstance', 'trsHttpService', 'item', "burstNewsRuleService", "modalDialog", function($scope, $modalInstance, trsHttpService, item, burstNewsRuleService, modalDialog) {
    initStatus();
    initData();
    /**
     * [initStatus description] 初始化状态
     * @return {[type]} [description]
     */
    function initStatus() {
        $scope.status = {
            pageNo: 0,
            pageSize: 10,
            wbSelect: false, //微博单选框
            wzSelect: false, //文章单选框
            hasId: false,
            bredcontinue: true,
        };
        $scope.data = {
            name: "", //规则名称
            content: "", //规则详情`
            editrange: "", //规则范围
            items: item, //接收传值
        };
    }
    /**
     * [initData description] 初始化数据
     * @return {[type]} [description]
     */
    function initData() {
        var params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentrulemgr',
            "modelid": 'getrule',
            "id": $scope.data.items.id,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            $scope.status.hasId = true;
            $scope.data.name = data.ruleName;
            $scope.data.content = data.content;
            if (data.range == 0) {
                $scope.status.wbSelect = true;
                $scope.status.wzSelect = true;
                $scope.data.editrange = 0;
            } else if (data.range == 1) {
                $scope.status.wbSelect = true;
                $scope.data.editrange = 1;
            } else if (data.range == 2) {
                $scope.status.wzSelect = true;
                $scope.data.editrange = 2;
            }
        });
    }

    /**
     * [chooseWay description]  选择渠道
     * @param  {[type]} type [description] 0 微博   1网站
     * @return {[type]}      [description]
     */
    $scope.chooseWay = function(type) {
        !type ? $scope.status.wbSelect = !$scope.status.wbSelect : $scope.status.wzSelect = !$scope.status.wzSelect;
        if ($scope.status.wbSelect || $scope.status.wzSelect) {
            $scope.status.way = true;
        } else {
            $scope.status.way = false;
        }
    };
    /**
     * [edittest description] 编辑保存前验证
     * @return {[type]} [description]
     */
    $scope.bredittest = function() {
        //判断规则名称是否存在
        $scope.status.bredcontinue = true;
        var params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentrulemgr',
            "modelid": 'getrulelist',
            "type": item.type,
            "search_word": '',
            "page_no": $scope.status.pageNo,
            "page_size": $scope.status.pageSize,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            for (var i = 0; i < data.content.length; i++) {
                if (data.content[i].ruleName == $scope.data.name) {
                    var dataId = data.content[i].id;
                    if (dataId != $scope.data.items.id) {
                        modalDialog.alertType('', '已存在此名称的记录!', 'warning', 'confirm');
                        $scope.status.bredcontinue = false;
                        return;
                    }
                }
            }
            if ($scope.status.bredcontinue == true) {
                if ($scope.status.wbSelect == true && $scope.status.wzSelect == true) {
                    $scope.data.editrange = '0';
                } else {
                    if ($scope.status.wbSelect == true) {
                        $scope.data.editrange = '1';
                    } else if ($scope.status.wzSelect == true) {
                        $scope.data.editrange = '2';
                    }
                }
                brruleedit();
            }
        });



    };
    /**
     * [ruleedit description] 编辑保存
     * @return {[type]} [description]
     */
    function brruleedit() {
        var params = {
            "typeid": 'screen',
            "serviceid": 'zjsentimentrulemgr',
            "modelid": 'saverule',
            "type": item.type,
            "id": $scope.data.items.id,
            "name": $scope.data.name,
            "content": $scope.data.content,
            "range": $scope.data.editrange,
        };
        $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
            $scope.status.saveright = true;
            modalDialog.alertType('', '编辑成功', 'success', false);
            $modalInstance.close(true);
        });
    }
    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.brcancel = function() {
        //如果标题或者内容有值调用窗口询问是否放弃
        if ($scope.data.name || $scope.data.content) {
            modalDialog.alertType('', '确定要放弃修改吗？', 'ask', true, function() {
                $modalInstance.dismiss();
            }, '');
        } else {
            $modalInstance.dismiss();
        }
    };

    /**
     * [cancel description] 取消
     * @return {[type]} [description]
     */
    $scope.cancel = function() {
        $modalInstance.dismiss();
    };

}]);